import { CharacterAvatarsFilters, CharacterAvatarType } from '@/types/schema';

import { useCharacterAvatarsQuery } from './graphql/queries/generated/characterAvatars';

export function useVideoCharacterAvatars({ filters }: { filters?: CharacterAvatarsFilters }) {
  const [{ data, fetching, error }] = useCharacterAvatarsQuery({
    variables: {
      filters,
    },
  });

  return {
    avatars: (data?.characterAvatars?.edges?.map((edge) => edge?.node) ||
      []) as CharacterAvatarType[],
    fetching,
    error,
    defaultAvatarValue: data?.characterAvatars?.edges?.[0]?.node?.avatar_id || '',
  };
}
